import script from "./ListWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ListWidget.vue?vue&type=script&setup=true&lang=js"

import "./ListWidget.vue?vue&type=style&index=0&id=76756471&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76756471"]])

export default __exports__